export default "__VITE_ASSET__CQI54Esk__"